import { render, staticRenderFns } from "./Postit.vue?vue&type=template&id=17790ea2&"
import script from "./Postit.vue?vue&type=script&lang=ts&"
export * from "./Postit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports